import React from 'react';
import safeStorage from '../lib/util/SafeStorage';

export const ConfigurationContext = React.createContext({
  debugEnabled: true, // default if no context was provided which is never
});


// context provider for application settings
class Configuration extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = {
      debugEnabled: false,
      tokenizeTimeout: 10000,
      iFrameHeight: 300,
      iFrameWidth: 1000,
      allowSelfMessagePost: false,
    }
    this.updateSetting = this.updateSetting.bind(this);
    this.resetSetting = this.resetSetting.bind(this);
  }
  
  componentDidMount()
  {
    try {
      const state = safeStorage.getItem('state');
      if (state) {
        const stateJson = JSON.parse(state);
        this.setState(stateJson);
      }
    } catch (e) {
      // Gracefully handle any Storage or JSON parse exception in Safari Private Browsing mode
    }
  }
  
  componentDidUpdate(prevProps, prevState)
  {
    try {
      safeStorage.setItem('state', JSON.stringify(this.state));
    } catch (e) {
      // Gracefully handle any Storage exception in Safari Private Browsing mode
    }
  }
  
  updateSetting(setting, value)
  {
    const currentSettingValue = this.state[setting];
    if (this.state.hasOwnProperty(setting) && typeof(value) == typeof(currentSettingValue))
    {
      const newConfig = Object.assign({}, this.state);
      let n = {};
      n[setting] = value;
      this.setState(n);
    }
  }
  
  resetSetting()
  {
    try {
      safeStorage.clear();
    } catch (e) {
      // Gracefully handle any Storage exception in Safari Private Browsing mode
    }
  }
  
  contextProps()
  {
    let methods = {
      updateSettingContext: this.updateSetting,
      resetSettingContext: this.resetSetting,
    }
    return {...this.state, ...methods}
  }
  
  render() {
    return (
      <ConfigurationContext.Provider
        children={this.props.children || null}
        value={this.contextProps()}
      />
    );
  }
}
export default Configuration;
